import React from "react";
import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import TopMenu from "./menus/TopMenu";

const ProtectedLayout = () => {
    return (
        <ProtectedRoute>
            <Box
                className="main-shell"
                sx={{
                    minHeight: "100vh",
                    "& .MuiContainer-root": {
                        px: { xs: "5px !important", sm: "10px", md: "14px" },
                    },
                }}
            >
                <TopMenu />
                <Container
                    maxWidth="xl"
                    sx={{
                        py: { xs: 2, md: 3 },
                        px: { xs: "5px !important", sm: "10px", md: "14px" },
                    }}
                >
                    <Outlet />
                </Container>
            </Box>
        </ProtectedRoute>
    );
};

export default ProtectedLayout;
